import StaffUsersList from "./StaffUsersList";
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import StaffUserCreate from "./StaffUserCreate";
import StaffUserEdit from "./StaffUserEdit";
import StaffUserView from "./StaffUserView";

export default {
    list: StaffUsersList,
    create: StaffUserCreate,
    edit: StaffUserEdit,
    show: StaffUserView,
    icon: SupervisorAccountIcon
}